import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const Ctx = createContext(null);

export function MemberProvider({ children }) {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/member/me");
      setMember(r.data);
    } catch (e) {
      if (e?.response?.status && e.response.status !== 401) logError("Member check failed", e);
      setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Area admin punya sesi sendiri — jangan panggil /member/me di sana (bikin 401 noise di console).
    if (window.location.pathname.startsWith("/admin")) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await api.post("/member/logout"); } catch (e) { logError("Member logout failed", e); }
    setMember(null);
    window.location.href = "/member/login";
  }, []);

  const value = useMemo(() => ({ member, loading, setMember, refresh, logout }), [member, loading, refresh, logout]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useMember = () => useContext(Ctx);
